import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort',
})
export class SortPipe implements PipeTransform {
  transform(
    value: any[],
    propertyName: string,
    order: 'asc' | 'desc' = 'asc',
  ): any[] {
    return value.sort((a, b) => {
      const x = a[propertyName];
      const y = b[propertyName];
      return order === 'asc' ? (x > y ? 1 : -1) : x < y ? 1 : -1;
    });
  }
}
